import React from "react";
import { CircleMarker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";
import { fileUrl } from "../../lib/api";
import { relTime } from "../../lib/incidents";

export const FieldPhotosLayer = ({ photos = [] }) => (
  <>
    {photos.map((p) => (
      <CircleMarker
        key={p.file_id}
        center={[p.latitude, p.longitude]}
        radius={9}
        pathOptions={{ color: "#0A0D0C", weight: 2, fillColor: "#E9C46A", fillOpacity: 0.95 }}
      >
        <Popup maxWidth={220}>
          <div style={{ width: 200 }} data-testid={`field-photo-popup-${p.file_id}`}>
            <a href={fileUrl(p.file_id)} target="_blank" rel="noreferrer">
              <img
                src={fileUrl(p.file_id)}
                alt="Field photo"
                style={{ width: "100%", height: 120, objectFit: "cover", borderRadius: 2 }}
              />
            </a>
            <div style={{ fontSize: 11, fontWeight: 700, marginTop: 6 }}>
              {p.author}{p.verified ? " · Verified" : ""}
            </div>
            <div style={{ fontSize: 11, opacity: 0.75 }}>{relTime(p.created_at)}</div>
            {p.message && (
              <div style={{ fontSize: 11, marginTop: 4 }}>
                {p.message.length > 90 ? `${p.message.slice(0, 90)}…` : p.message}
              </div>
            )}
            {p.incident_id && (
              <Link
                to={`/incident/${p.incident_id}`}
                data-testid={`field-photo-incident-link-${p.file_id}`}
                style={{ fontSize: 11, fontWeight: 700, display: "inline-block", marginTop: 6 }}
              >
                {p.incident_name ? `→ ${p.incident_name}` : "→ View incident"}
              </Link>
            )}
          </div>
        </Popup>
      </CircleMarker>
    ))}
  </>
);

export default FieldPhotosLayer;
